import { OtpBoxes } from "./OtpBoxes";
import { ConsentModal } from "./ConsentModal";

/* Email → "Send code" → link/code step. `compact` tightens headings for the landing-page modal. */
export const AuthForm = ({ auth, compact = false }) => {
  const { email, setEmail, code, setCode, sent, showCode, setShowCode, cooldown, error, info, busy, sendCode, verify, changeEmail, iosApp, consentOpen, closeConsent, confirmConsent } = auth;
  const H = compact ? "text-xl font-bold mb-4" : "text-2xl font-bold mb-6";
  return (
    <>
      {!sent ? (
        <>
          <p className="eyebrow mb-2">Passwordless</p>
          <h2 className={H}>Enter your email. We'll send a code.</h2>
          <form onSubmit={sendCode} className="flex flex-col gap-3">
            <input data-testid="auth-email-input" className="field" type="email" placeholder="you@example.com" value={email}
              onChange={(e) => setEmail(e.target.value)} required autoComplete="email" autoFocus />
            <button data-testid="auth-send-code-button" className="btn-primary mt-2" disabled={busy || cooldown > 0}>
              {busy ? "Sending…" : cooldown ? `Resend in ${cooldown}s` : "Continue"}
            </button>
          </form>
          <ConsentModal open={consentOpen} mode="otp" busy={busy} onConfirm={confirmConsent} onClose={closeConsent} />
        </>
      ) : iosApp ? (
        <div data-testid="auth-code-first">
          <p className="eyebrow mb-2">Check your email</p>
          <h2 className={`${compact ? "text-xl" : "text-2xl"} font-bold mb-1`} data-testid="auth-code-heading">Enter the code from your email</h2>
          <p className="text-sm text-muted mb-4" data-testid="auth-code-hint">We sent it to <strong className="text-[#f2f5f8]">{email}</strong>. On iPhone, tapping the link opens Safari instead of the app — the code signs you in here.</p>
          <form onSubmit={verify} className="flex flex-col gap-3" data-testid="auth-code-form">
            <OtpBoxes value={code} onChange={setCode} onComplete={(v) => verify(null, v)} />
            <button data-testid="auth-verify-button" className="btn-primary" disabled={busy || code.length < 6}>{busy ? "Verifying…" : "Log in with code"}</button>
          </form>
          <p className="text-xs text-muted mt-4" data-testid="auth-link-secondary">Prefer the link? Opening it signs you in in Safari, not in this app.</p>
          <div className="flex justify-between mt-4 text-sm">
            <button type="button" data-testid="auth-change-email" className="text-muted hover:underline" onClick={changeEmail}>Change email</button>
            <button type="button" data-testid="auth-resend-button" className="text-muted hover:underline" disabled={cooldown > 0 || busy} onClick={sendCode}>{cooldown ? `Resend in ${cooldown}s` : "Resend email"}</button>
          </div>
        </div>
      ) : (
        <>
          <p className="eyebrow mb-2">Check your email</p>
          <h2 className={`${compact ? "text-xl" : "text-2xl"} font-bold mb-1`} data-testid="auth-link-heading">Tap the sign-in link in your email</h2>
          <p className="text-sm text-muted mb-2" data-testid="auth-sent-to">We sent it to <strong className="text-[#f2f5f8]">{email}</strong>. Opening the link on this device signs you in.</p>
          <button type="button" data-testid="auth-resend-button" className="btn-secondary mt-3" disabled={cooldown > 0 || busy} onClick={sendCode}>{cooldown ? `Resend in ${cooldown}s` : "Resend email"}</button>
          <button type="button" data-testid="auth-code-toggle" className="mt-5 text-sm text-muted hover:underline" onClick={() => setShowCode(!showCode)}>{showCode ? "Hide code entry" : "Have a code instead? Enter it here"}</button>
          {showCode && (
            <form onSubmit={verify} className="flex flex-col gap-3 mt-3" data-testid="auth-code-form">
              <input data-testid="auth-otp-input" className="field otp" inputMode="numeric" maxLength={8} placeholder="••••••" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} autoFocus />
              <button data-testid="auth-verify-button" className="btn-primary" disabled={busy || code.length < 6}>{busy ? "Verifying…" : "Log in with code"}</button>
            </form>
          )}
          <div className="flex justify-between mt-6 text-sm">
            <button type="button" data-testid="auth-change-email" className="text-muted hover:underline" onClick={changeEmail}>Change email</button>
          </div>
        </>
      )}
      {info && <p data-testid="auth-info" className="mt-4 text-sm text-[#2ECC71]">{info}</p>}
      {error && <p role="alert" data-testid="auth-error" className="mt-4 text-sm text-[#FF7A7A]">{error}</p>}
    </>
  );
};
